import React, { useState, useEffect } from "react";
import { SettingOutlined } from "@ant-design/icons";
import "../../styles.scss";
import { formatNumber } from '../../../../services/mixin';
import MegaTable from "../../../../components/MagaTableV2";

const ContactInformation = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_transactions?.list.map((col: any) => {
      if (col.field === 'vehicle_type_category') {
        temp.push({
          field: col.field,
          headerName: col.headerName,
          cellRenderer: (params: any) => {
            if (params.data.vehicle_type_category === 'TB') {
              return 'Tải Bus'
            } else if (params.data.vehicle_type_category === 'DL') {
              return 'Du lịch'
            } else {
              return params.data.vehicle_type_category
            }
          }
        })
      } else if (col.field === 'total_amount' || col.field === 'unit_price') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheContractInformation',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // {
      //   field: "vehicle_type_category", headerName: "Dòng xe", cellRenderer: (params: any) => {
      //     if (params.data.vehicle_type_category === 'TB') {
      //       return 'Tải Bus'
      //     } else if (params.data.vehicle_type_category === 'DL') {
      //       return 'Du lịch'
      //     } else {
      //       return params.data.vehicle_type_category
      //     }
      //   }
      // },
      // { field: 'engine_no', headerName: 'Số máy' },
      // { field: 'color_name', headerName: 'Màu nội thất' },
      // { field: 'engine_type', headerName: 'Loại động cơ' },
      // { field: 'contract_date', headerName: 'Ngày hợp đồng' },
      // { field: 'contract_no', headerName: 'Số hợp đồng' },
      // { field: 'doc_no', headerName: 'Số hóa đơn' },
      // { field: 'contract_doc_date', headerName: 'Ngày xuất hóa đơn' },
      // { field: 'payment_terms_name', headerName: 'Hình thức thanh toán' },
      // {
      //   field: 'total_amount',
      //   headerName: 'Tổng tiền',
      //   valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },
      // {
      //   field: 'unit_price',
      //   headerName: 'Giá xe',
      //   valueFormatter: (params: any) =>
      //     formatNumber(params.value),
      // },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  useEffect(() => {
    if (stData.xesohuu_show) {
      stChange(stData.xesohuu_show.vehicle_contract || [], 'vehicle_contract');
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesohuu_show_vehicle_contract || [], loading: false }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};

export default ContactInformation;
